module.exports = __webpack_public_path__ + "img/C08TechBowmanChampion_ua.b1e4195c.webp";